export function mrpRfqUserIdsMatch(left: string, right: string): boolean {
  return left.trim().toLowerCase() === right.trim().toLowerCase();
}

export function mrpRfqAssigneePatchMessage(
  assignedToUserId: string | null | undefined,
  currentUserId: string,
): string | null {
  if (assignedToUserId === undefined) {
    return null;
  }
  if (assignedToUserId === null) {
    return "Assignee cleared.";
  }
  if (mrpRfqUserIdsMatch(assignedToUserId, currentUserId)) {
    return "You are now assigned to this RFQ.";
  }
  return "Assignee updated.";
}
